<template>
  <div class="element-list container-fluid bottom-dotted-border margin-Top-Bottom-1Point5Perc">
    <div class="admin-Panel-Padding">
      <div class="row vertical-align">
        <div class="col-md-1 col-lg-1">
          <!-- ToDo: Track this -->
          <img src= "../assets/images/reorder.svg" class="cursor-pointer img-responsive opacity-point-2 icon-width-height align-center" alt="drag">
        </div>
        <div class="col-md-1 col-lg-1">
          <div class="align-center">
            <div class="element-index-circle-width-height roundered-corner displayFlex" :class="{'background-color-orange' : this.ElementObj.Type === 7}">
              <div class="element-index-font-style widthInherit fontSize17px marginTop2perc" :class="{'font-weight-bold': this.ElementObj.Type === 7, 'fontSize14px': this.ElementObj.Type !== 7 && parseInt(getDisplayIndexLength) < 3, 'fontSize12px' : this.ElementObj.Type !== 7 && parseInt(getDisplayIndexLength) >= 3}">
                {{getStringIndex}}
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-8 col-lg-8 border-red" @click="openSelectedOverlay" v-bind:class="{'cursor-pointer': parseInt(this.ElementObj.Type) !== 1 && parseInt(this.ElementObj.Type) !== 3}"> -->
        <div class="col-md-7 col-lg-7" @click="openSelectedOverlay" v-bind:class="{'cursor-pointer': (parseInt(this.ElementObj.Type) !== 1) && (parseInt(this.ElementObj.Type) !== 12)}">
        <div class="row vertical-align">
          <!-- <div class="row"> -->
            <!-- <div class="col-md-12 col-lg-12 text-align-left orange-text-color">
              <div class="left-icon-div">
                  <img :src= "elementImgSrc" class="img-responsive element-icon-width-height" alt="element-icon">
              </div>
              <div class="right-element-duration-div">
                  / {{ElementObj.Duration}}
              </div>
              <div class="middle-element-type-name-div element-type-font-style">
                  {{elementType}}
              </div>
          </div> -->
          <div class="col-sm-1 col-md-1 col-lg-1 ">
            <img :src= "elementImgSrc" class="img-responsive element-icon-width-height" alt="element-icon">
          </div>
          <div class="col-sm-5 col-md-5 col-lg-5 padding-left-0Perc padding-right-0Perc text-align-left orange-text-color">
            <span class="element-type-font-style">{{elementType}} </span>
            <span v-if="ElementObj.Type !== 7">
              / {{ElementObj.Duration}}
            </span>
            <span class="tooltip1 cursor-default margin-left-2px">
              <img :src= "getIncludeInProgressSrcValue" class="include-in-progress-width-height margin-right-0px" alt="includeInProgressIcon">
              <span class="tooltiptext1">{{getIncludeInProgressTooltipValue}}</span>
            </span>
            <span class="tooltip1 margin-0px cursor-default" v-if="ElementObj.Type === 7">
              <img :src="bonusIcon" class="include-in-progress-width-height" alt="bonusIcon">
              <span class="tooltiptext1">{{getIsBonusContentTooltipValue}}</span>
            </span>
          </div>
          <!-- <div class="col-sm-1 col-md-1 col-lg-1 border-red">
            <img :src= "getIncludeInProgressSrcValue" class="img-responsive include-in-progress-width-height" alt="includeInProgressIcon">
        </div> -->
          <div class="col-sm-6 col-md-6 col-lg-6">
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-align-left orange-text-color element-name-text-size element-name-style">
            {{ElementObj.Title}}
          </div>
        </div>
      </div>
      <div class="col-md-1 col-lg-1">
        <img src= "../assets/images/edit.svg" class="cursor-pointer img-responsive opacity-point-5 icon-width-height align-center" alt="edit" @click="openRespectiveEditOverlay">
      </div>
      <div class="col-md-1 col-lg-1">
          <img src= "../assets/images/delete.svg" class="cursor-pointer img-responsive opacity-point-5 icon-width-height align-center" alt="delete" v-on:click="setShowConfirmationBoxAsTrue($event,true)">
          <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="ElementObj" v-bind:prefixString="prefixDeleteElementString" v-bind:postfixString="postDeleteElementString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedElement"></confirmation-alert>
      </div>
      <div class="col-md-1 col-lg-1" v-if="getRuleOptionVisibility">
        <img src= "../assets/images/rules.png" class="cursor-pointer img-responsive opacity-point-5 icon-width-height align-center" alt="edit" @click="openRuleOverlay"></div>
      </div>
    </div>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <view-document-element-overlay v-if="viewDocumentElemOverlay" @closeOverlay="closeOverlay" v-bind:elementObj="ElementObj" v-bind:lessonObj="lessonObj"></view-document-element-overlay>
    <view-reflection-discussion-overlay v-if="viewRDElemOverlay" @closeOverlay="closeOverlay" v-bind:elementObj="ElementObj" v-bind:lessonObj="lessonObj"></view-reflection-discussion-overlay>
    <view-note-element-overlay v-if="viewNoteElemOverlay" @closeOverlay="closeOverlay" v-bind:elementObj="ElementObj" v-bind:lessonObj="lessonObj"></view-note-element-overlay>
    <!-- start:view MCQ Element Overlay -->
    <view-mcq-element-overlay v-if="viewMCQElemOverlay" @closeOverlay="closeOverlay" v-bind:ElementObj="ElementObj" v-bind:lessonObj="lessonObj"></view-mcq-element-overlay>
    <!-- <update-mcq-element v-if="showUpdateMCQOverlay" @closeUpdateMCQOverlay="closeUpdateMCQOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-mcq-element> -->

    <!-- end:view MCQ Element Overlay -->
    <view-post-element-overlay v-if="viewPostElemOverlay" @closeOverlay="closeOverlay" v-bind:elementObj="ElementObj" v-bind:lessonObj="lessonObj"></view-post-element-overlay>
    <view-video-element-overlay v-if="viewVideoElemOverlay" @closeOverlay="closeOverlay" v-bind:elementObj="ElementObj" v-bind:lessonObj="lessonObj"></view-video-element-overlay>
    <!-- start:adaptive game -->
    <view-adaptive-game-element-overlay v-if="viewAdaptiveGameElementOverlay" @closeOverlay="closeOverlay" v-bind:elementObj="ElementObj" v-bind:lessonObj="lessonObj"></view-adaptive-game-element-overlay>
    <!-- end:adaptive game -->
    <view-video-text-element-overlay v-if="viewVideoTextElemOverlay" @closeOverlay="closeOverlay" v-bind:elementObj="ElementObj" v-bind:lessonObj="lessonObj"></view-video-text-element-overlay>
    <update-lesson-overlay v-show="showUpdateLessonOverlay" @ShowUpdateLesson="updateShowUpdateLessonFlag" @showSpinner="updateShowSpinnerFlag" v-bind:selectedLessonObj="currBonusLessonObj"></update-lesson-overlay>
    <add-bonus-video-overlay v-if="showAddBonusVideoElementOverlay" v-bind:bonusModuleServerRespObj="currBonusLessonObj" @closeAddBonusContent="upateAddBonusContentOverlayFlag" v-bind:comingFromLessonListAddOption="true" v-bind:selectedLessonObj="null"></add-bonus-video-overlay>
    <view-bonus-lesson v-if="viewBonusLessonContent" v-bind:lessonObj="lessonObj" v-bind:bonusLessonObj="currBonusLessonObj" v-bind:elementObj="ElementObj" @closeOverlay="closeOverlay" @selectedOperation="performOperationOnBonusElement"></view-bonus-lesson>
    <!-- <loader></loader> -->
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <update-note-element v-if="showUpdateNoteOverlay" @closeUpdateNoteOverlay="closeUpdateNoteOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-note-element>
    <update-post-element v-if="showUpdatePostElementOverlay" @closeUpdatePostElementOverlay="closeUpdatePostElementOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-post-element>
    <update-video-element v-if="showUpdateVideoOverlay" @closeUpdateVideoOverlay="closeUpdateVideoOverlay" v-bind:lessonObj="currBonusLessonObj" v-bind:ElementObj="currElementObj" @refreshElementList="refreshElementList"></update-video-element>
    <update-video-text-element v-if="showUpdateVideoTextOverlay" @closeUpdateVideoOverlay="closeUpdateTextVideoOverlay" v-bind:lessonObj="currBonusLessonObj" v-bind:ElementObj="currElementObj" @refreshElementList="refreshElementList"></update-video-text-element>
    <update-document-element v-if="showUpdateDocumentOverlay" @closeUpdateDocumentOverlay="closeUpdateDocumentOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-document-element>
    <update-reflection-discussion-element v-if="showUpdateRDOverlay" @closeUpdateRDOverlay="closeUpdateRDOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-reflection-discussion-element>
    <update-assessment-element  v-if="showUpdateAssessmentOverlay" @closeUpdateAssessmentOverlay="closeUpdateAssessmentOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-assessment-element>
    <update-challenge-element v-if="showUpdateChallengeOverlay" @closeUpdateChallengeOverlay="closeUpdateChallengeOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-challenge-element>

    <update-mcq-element v-if="showUpdateMCQOverlay" @closeUpdateMCQOverlay="closeUpdateMCQOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-mcq-element>
    <update-bonus-content-element v-if="showUpdateBonusContentOverlay" @showAssociateMsg="updateShowAssociateMsgFlag" @closeUpdateBonusContentOverlay="closeUpdateBonusContentOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList" v-bind:showAssociateMsg="showMsg" v-bind:isBonusModuleCreated="isBonusModuleCreated" @openBonusModuleCreationOverlay="openBonusModuleCreationOverlay"></update-bonus-content-element>
    <create-bonus-module-overlay v-if="showBonusModuleCreationOverlay" @closeBonusModuleOverlay="closeBonusOverlay" @isBonusModuleCreated="updateNotCreatedBonusModule" v-bind:selectedLessonObj="lessonObj"></create-bonus-module-overlay>
    <update-adaptive-game-overlay v-if="showUpdateAdaptiveGameOverlay" @closeUpdateAdaptiveGameOverlay="closeUpdateAdaptiveGameOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></update-adaptive-game-overlay>
    <update-mission-element v-if="showUpdateMissionOverlay" @closeUpdateMissionOverlay="closeUpdateMissionOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="getCurrentMissionElementObj" @refreshElementList="refreshElementList" @udpatedCurrentElemObj="updateCurrMissionElementObj"></update-mission-element>

    <add-rule-overlay v-if="showRuleOverlay" @closeShowRuleOverlay="closeShowRuleOverlay" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" @refreshElementList="refreshElementList"></add-rule-overlay>
  </div>
</template>

<script>
import AddBonusVideoOverlay from '@/components/AddBonusVideoOverlay'
import Loader from '@/components/dashboard/Loader'
import ViewBonusLesson from '@/components/view_element/ViewBonusLesson'
import ViewVideoElementOverlay from '@/components/view_element/ViewVideoElementOverlay'
import ViewAdaptiveGameElementOverlay from '@/components/view_element/ViewAdaptiveGameElementOverlay'
import ViewNoteElementOverlay from '@/components/view_element/ViewNoteElementOverlay'
import ViewMcqElementOverlay from '@/components/view_element/ViewMCQElementOverlay'
import ViewReflectionDiscussionOverlay from '@/components/view_element/ViewReflectionDiscussionOverlay'
import ViewDocumentElementOverlay from '@/components/view_element/ViewDocumentElementOverlay'
import ViewVideoTextElementOverlay from '@/components/view_element/ViewVideoTextElementOverlay'
import ViewPostElementOverlay from '@/components/view_element/ViewPostElementOverlay'
import { constants } from '@/utils/constants'
// import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { elementService } from '@/server-util/element-service'
import { moduleService } from '@/server-util/module-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import UpdateNoteElement from '@/components/UpdateNoteElement'
import UpdatePostElement from '@/components/UpdatePostElement'
import UpdateVideoElement from '@/components/UpdateVideoElement'
import UpdateMissionElement from '@/components/mission_game/update/UpdateMissionGameOverlay'
import UpdateVideoTextElement from '@/components/UpdateVideoTextElement'
import UpdateDocumentElement from '@/components/UpdateDocumentElement'
import UpdateReflectionDiscussionElement from '@/components/UpdateReflectionDiscussionElement'
import UpdateChallengeElement from '@/components/UpdateChallengeElement'
import AddRuleOverlay from '@/components/personalization_rule/AddRuleOverlay'
import UpdateMCQElement from '@/components/UpdateMCQElement'
import UpdateBonusContentElement from '@/components/UpdateBonusContentElement'
import CreateBonusModuleOverlay from '@/components/CreateBonusModuleOverlay'
import videoicon from '../assets/images/videoicon.svg'
import challengeicon from '../assets/images/challengeicon.svg'
import reflectionicon from '../assets/images/reflectionicon.svg'
import mcqicon from '../assets/images/mcqicon.svg'
import noteicon from '../assets/images/noteicon.svg'
import iconadaptivegame from '../assets/images/iconadaptivegame.svg'
import documenticon from '../assets/images/documents.svg'
import missionicon from '../assets/images/mission.svg'
import UpdateLessonOverlay from '@/components/UpdateLessonOverlay'
import excludeinprogressicon from '../assets/images/excludeinprogress.svg'
import includeinprogressicon from '../assets/images/includeinprogress.svg'
import bonusicon from '../assets/images/bonus.svg'
import UpdateAssessmentElement from '@/components/UpdateAssessmentElement'

import UpdateAdaptiveGameOverlay from '@/components/adaptive_game/Update-element/UpdateAdaptiveGameOverlay'
export default {
  props: ['lessonObj', 'ElementObj', 'elementList'],
  name: 'element-list',
  created () {
    this.setDefaultValues()
    this.setElementImageAndType()
  },
  data: function () {
    // console.log(JSON.stringify(this.elementList))
    return {
      constants: constants,
      includeInProgressTooltip: '',
      isBonusContentTooltip: '',
      includeInProgressSrc: '',
      bonusSrc: '',
      elementImgSrc: '',
      elementType: '',
      showConfirmationBox: false,
      prefixDeleteElementString: 'Are you sure you want to delete ',
      postDeleteElementString: '?',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      showUpdateNoteOverlay: false,
      showUpdateVideoOverlay: false,
      showUpdateVideoTextOverlay: false,
      showUpdateDocumentOverlay: false,
      showUpdateRDOverlay: false,
      showUpdateAssessmentOverlay: false,
      showUpdateChallengeOverlay: false,
      showUpdateMCQOverlay: false,
      showUpdateBonusContentOverlay: false,
      showBonusModuleCreationOverlay: false,
      showUpdatePostElementOverlay: false,
      showRuleOverlay: false,
      showMsg: false,
      isBonusModuleCreated: true,
      viewBonusLessonContent: false,
      currElementObj: null,
      currBonusLessonObj: null,
      isComingFromViewBonusContent: false,
      showAddBonusVideoElementOverlay: false,
      showUpdateLessonOverlay: false,
      viewVideoElemOverlay: false,
      viewAdaptiveGameElementOverlay: false,
      viewNoteElemOverlay: false,
      viewMCQElemOverlay: false,
      viewPostElemOverlay: false,
      viewRDElemOverlay: false,
      viewDocumentElemOverlay: false,
      viewVideoTextElemOverlay: false,
      bonusIcon: bonusicon,
      showUpdateAdaptiveGameOverlay: false,
      showUpdateMissionOverlay: false,
      currMissionElementObj: null,
      showDisplayIndex: '',
      displayIndexLen: 1
    }
  },
  methods: {
    updateShowUpdateLessonFlag (value) {
      // AK: Used when user pressed close button of update lesson overlay
      this.showUpdateLessonOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
      // if (this.isComingFromViewBonusContent) {
      this.isComingFromViewBonusContent = false
      this.viewBonusLessonContent = true
      this.getSelectedBonusLessonObj()
      // }
    },
    updateShowSpinnerFlag (value) {
      // AK: As Soon as User update request send to server show spinner and Hide spinner after recieving updated list
      // this.showSpinner = value
      this.$store.state.isLoading = value
      // if (this.isComingFromViewBonusContent) {
      this.isComingFromViewBonusContent = false
      this.viewBonusLessonContent = true
      this.getSelectedBonusLessonObj()
      // }
    },
    upateAddBonusContentOverlayFlag (value) {
      // AK: Close Add bonus video overlay
      this.showAddBonusVideoElementOverlay = value
      // AK: Again open Bonus Content list overlay
      this.viewBonusLessonContent = true
      this.getSelectedBonusLessonObj()
    },
    performOperationOnBonusElement (value) {
      // AK: Perform selected operation on Selected Bonus Video Element
      switch (value.selectedOperation) {
        case 'edit':
          this.currElementObj = value.selectedElemObj
          this.viewBonusLessonContent = false
          this.showUpdateVideoOverlay = true
          // AK: As user coming from Bonus Content then set flag to true
          this.isComingFromViewBonusContent = true
          break
        case 'create':
          // this.getSelectedBonusLessonObj()
          this.currBonusLessonObj = value.selectedBonusObj
          this.viewBonusLessonContent = false
          this.showAddBonusVideoElementOverlay = true
          // AK: As user coming from Bonus Content then set flag to true
          this.isComingFromViewBonusContent = true
          break
        case 'update_bonus_lesson':
          // this.getSelectedBonusLessonObj()
          this.currBonusLessonObj = value.selectedBonusObj
          this.viewBonusLessonContent = false
          this.showUpdateLessonOverlay = true
          break
      }
    },
    setDefaultValues: function () {
      // AK: Set default element obj to currElementObj
      this.currElementObj = this.ElementObj
      this.showDisplayIndex = this.currElementObj.DisplayIndex
      this.displayIndexLen = this.showDisplayIndex.length
      this.currBonusLessonObj = this.lessonObj
    },
    updateCurrMissionElementObj (value) {
      this.currMissionElementObj = value
      // console.log('updateCurrMissionElementObj: ' + JSON.stringify(this.currMissionElementObj))
    },
    getSelectedBonusLessonObj: function () {
      for (var i = 0; i < this.$store.state.selectedMasterClassModuleList.length; i++) {
        var currModObj = this.$store.state.selectedMasterClassModuleList[i]
        if (this.ElementObj.BonusModuleId === currModObj.ModuleId) {
          this.currBonusLessonObj = currModObj
          break
        }
      }
    },
    openSelectedOverlay: function () {
      // console.log('this.getBonusElemObj >>> ' + JSON.stringify(this.ElementObj))
      switch (this.ElementObj.Type) {
        case 7:
          // AK: If Bonus element is not associate with any lesson then throw alert to associate first
          if (this.ElementObj.BonusModuleId !== '00000000-0000-0000-0000-000000000000' && this.ElementObj.BonusModuleId !== null && this.ElementObj.BonusModuleId !== 'null') {
            this.getSelectedBonusLessonObj()
            // AK: Open Bonus Lesson Overlay
            this.viewBonusLessonContent = true
            // this.getSelectedBonusLessonObj()
            // AK: Disable background scrolling
            this.$store.state.isOverlayVisible = true
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Please associate bonus content with this step first, using edit option.'
          }
          break
        case 0:
          this.viewVideoElemOverlay = true
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 6:
          this.viewNoteElemOverlay = true
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 2:
          this.viewRDElemOverlay = true
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 8:
          this.viewDocumentElemOverlay = true
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 9:
          this.viewVideoTextElemOverlay = true
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 10:
          this.viewPostElemOverlay = true
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 11:
          this.viewAdaptiveGameElementOverlay = true
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 3:
          this.viewMCQElemOverlay = true
          // AK: Disable background scrolling
          this.$store.state.isOverlayVisible = true
          break
      }
    },
    closeOverlay (value) {
      // AK: Used to close the overlay
      this.viewBonusLessonContent = value.closeOverlay
      this.viewVideoElemOverlay = value.closeOverlay
      this.viewAdaptiveGameElementOverlay = value.closeOverlay
      this.viewNoteElemOverlay = value.closeOverlay
      this.viewMCQElemOverlay = value.closeOverlay
      this.viewRDElemOverlay = value.closeOverlay
      this.viewDocumentElemOverlay = value.closeOverlay
      this.viewVideoTextElemOverlay = value.closeOverlay
      this.viewPostElemOverlay = value.closeOverlay
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value.closeOverlay
      // AK: Refresh element list (for showing updated name of Bonus module if changed by user)
      this.getElements(false)
    },
    updateShowAssociateMsgFlag (value) {
      // AK: After showing msg to user on create bonus element set flag again as flase
      this.showMsg = false
    },
    updateNotCreatedBonusModule (value) {
      // AK: If user created/ already present bonus module then update flag as true else false
      this.isBonusModuleCreated = value
      // AK: If bonus module created then only set showMsg as true
      if (value === true) {
        this.showMsg = true
      }
    },
    openBonusModuleCreationOverlay (value) {
      // AK: Used to show bonus module creation overlay
      this.showBonusModuleCreationOverlay = value
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeBonusOverlay (value) {
      // AK: Used to hide bonus module creation overlay if user pressed X explicitly
      this.showBonusModuleCreationOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value

      // AK: Again open add bonus content overlay
      this.showUpdateBonusContentOverlay = true
      // AK: Disabled Background Scrolling
      this.$store.state.isOverlayVisible = true
    },
    openRespectiveEditOverlay (event) {
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = true
      switch (this.ElementObj.Type) {
        case 0:
          this.elementImgSrc = videoicon
          this.currElementObj = this.ElementObj
          this.showUpdateVideoOverlay = true
          this.elementType = 'Video'
          break
        case 1:
          this.elementImgSrc = challengeicon
          this.showUpdateChallengeOverlay = true
          if (parseInt(this.ElementObj.SubType) === parseInt(constants.DescVideoType.Teachback)) {
            this.elementType = 'Teachback'
          } else {
            this.elementType = 'Challenge'
          }
          break
        case 2:
          this.elementImgSrc = reflectionicon
          this.showUpdateRDOverlay = true
          this.elementType = 'Reflection'
          break
        case 3:
          this.elementImgSrc = mcqicon
          this.showUpdateMCQOverlay = true
          this.elementType = 'MCQ'
          break
        case 4:
          this.elementImgSrc = videoicon
          this.elementType = 'Tookit'
          break
        case 5:
          this.elementImgSrc = videoicon
          this.elementType = 'Diary'
          break
        case 6:
          this.elementImgSrc = noteicon
          this.showUpdateNoteOverlay = true
          this.elementType = 'Note'
          break
        case 7:
          this.elementImgSrc = videoicon
          this.showUpdateBonusContentOverlay = true
          // AK: Reset flag again in order to check if user created bonus module using create lesson option
          this.isBonusModuleCreated = true
          this.elementType = 'Bonus'
          break
        case 8:
          this.elementImgSrc = documenticon
          this.showUpdateDocumentOverlay = true
          this.elementType = 'Document'
          break
        case 9:
          this.elementImgSrc = videoicon
          this.currElementObj = this.ElementObj
          this.showUpdateVideoTextOverlay = true
          // console.log(this.currElementObj)
          if (parseInt(this.currElementObj.RDType) === parseInt(constants.DescVideoType.Teachback)) {
            this.elementType = 'Teachback'
          } else {
            this.elementType = 'Descriptive Video'
          }
          break
        case 10:
          this.elementImgSrc = noteicon
          this.showUpdatePostElementOverlay = true
          this.elementType = 'Rating'
          break
        case 11:
          this.elementImgSrc = iconadaptivegame
          this.showUpdateAdaptiveGameOverlay = true
          this.elementType = 'Learning Game'
          break
        case 12:
          // console.log('this.ElementObj >>>> ' + JSON.stringify(this.ElementObj))
          this.currMissionElementObj = this.ElementObj
          this.elementImgSrc = missionicon
          this.showUpdateMissionOverlay = true
          this.elementType = 'Mission'
          break
        case 14:
          // console.log('this.ElementObj >>>> ' + JSON.stringify(this.ElementObj))
          this.elementImgSrc = mcqicon
          this.showUpdateAssessmentOverlay = true
          this.elementType = 'Assessment'
          break
      }
    },
    // SS: Add Rule
    openRuleOverlay (event) {
      // AK: Disable background scrolling
      this.$store.state.isOverlayVisible = true
      this.showRuleOverlay = true
    },
    // SS: Add Rule End
    closeUpdateBonusContentOverlay (value) {
      // AK: Close Update MCQ overlay
      this.showUpdateBonusContentOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeUpdateMCQOverlay (value) {
      // AK: Close Update MCQ overlay
      this.showUpdateMCQOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    // adaptive overlay start
    closeUpdateAdaptiveGameOverlay (value) {
      // ss:close Update AdaptiveGameOverlay
      this.showUpdateAdaptiveGameOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    // adaptive overlay start end
    closeUpdateChallengeOverlay (value) {
      // AK: Close Update Challenge overlay
      this.showUpdateChallengeOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    // ss: close add rule overlay
    closeShowRuleOverlay (value) {
      // SS: Close Update Challenge overlay
      this.showRuleOverlay = value
      this.$store.state.isOverlayVisible = value
    },
    closeUpdateRDOverlay (value) {
      // AK: Close Update RD overlay
      this.showUpdateRDOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeUpdateAssessmentOverlay (value) {
      // AK: Close Update Assessment overlay
      this.showUpdateAssessmentOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeUpdateDocumentOverlay (value) {
      // AK: Close Update Document overlay
      this.showUpdateDocumentOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    refreshElementList (value) {
      // AK: After perfered any update operation, refresh Element list
      if (value) {
        this.getElements(true)
        // AK: Used to open Bonus Screen if its coming from View Bonus Content Screen
        if (this.isComingFromViewBonusContent) {
          this.isComingFromViewBonusContent = false
          this.viewBonusLessonContent = true
          this.getSelectedBonusLessonObj()
        }
      }
    },
    closeUpdateNoteOverlay (value) {
      // AK: Close Update note overlay
      this.showUpdateNoteOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeUpdateMissionOverlay (value) {
      // AK: Close Update mission overlay
      this.showUpdateMissionOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeUpdatePostElementOverlay (value) {
      // AK: Close Update note overlay
      this.showUpdatePostElementOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    closeUpdateVideoOverlay (value) {
      // AK: Close Update Video overlay
      this.showUpdateVideoOverlay = value
      this.setDefaultValues()
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
      // AK: Used to open Bonus Screen if its coming from View Bonus Content Screen
      if (this.isComingFromViewBonusContent) {
        this.isComingFromViewBonusContent = false
        this.viewBonusLessonContent = true
        this.getSelectedBonusLessonObj()
      }
    },
    closeUpdateTextVideoOverlay (value) {
      this.showUpdateVideoTextOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    setShowConfirmationBoxAsTrue: function (event, flagToUpdate) {
      // AK: Used when user pressed delete button to open delete lesson overlay
      this.showConfirmationBox = flagToUpdate
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    deleteSelectedElement (value) {
      // AK: Hide Delete Confirmation Box
      this.showConfirmationBox = false
      var currElemArrIndex = parseInt(this.ElementObj.DisplayIndex) - 1
      // console.log('currElemArrIndex ' + currElemArrIndex)
      var beforeSelectedStepObj = this.getElementList[parseInt(currElemArrIndex) - 1]
      var afterSelectedStepObj = this.getElementList[parseInt(currElemArrIndex) + 1]
      if (beforeSelectedStepObj !== undefined && afterSelectedStepObj !== undefined) {
        // console.log('beforeSelectedStepObj ' + JSON.stringify(beforeSelectedStepObj))
        // console.log('afterSelectedStepObj ' + JSON.stringify(afterSelectedStepObj))
        if (parseInt(beforeSelectedStepObj.Type) === 7 && parseInt(afterSelectedStepObj.Type) === 7) {
          this.showAlertDialog = true
          this.errorMsg = 'Deleting the \'' + this.ElementObj.Title + '\' step will result in successive bonus steps hence current operation is not allowed.'
          return
        }
      }
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.ElementObj.ElementId !== undefined ||
          this.ElementObj.length > 0
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          elementService
            .deleteElement(storeObj.state.access_token, _this.ElementObj.ElementId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Element List
                _this.getElements(true)
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected Lesson Object is NULL hence declined DELETE OPERATION'
          )
        }
      }
    },
    getElements: function (showSpinnerToUser) {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      // AK: If show spinner if flag set to true
      if (showSpinnerToUser) {
        _this.$store.state.isLoading = true
      }
      // alert(this.LessonObj.ModuleId)
      if (
        this.ElementObj.ModuleId !== undefined ||
        this.ElementObj.ModuleId !== null ||
        this.ElementObj.length > 0
      ) {
        elementService
          .listElements(storeObj.state.access_token, this.ElementObj.ModuleId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Refresh Modules (For duration update)
              _this.refreshModules()
              // AK: Hide Spinner after recieving updated Element list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              // AK: In order to show newly refreshed Element List (Emitted to Lesson List)
              _this.$emit('updatedElementList', responseObj.data)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'ElementId is NULL hence declined LOADING ELEMENT LIST OPERATION [AFTER DELETEING]'
        )
      }
    },
    refreshModules: function () {
      var storeObj = this.$store
      // _this.showSpinner = true
      // alert(this.LessonObj.ModuleId)
      if (storeObj.state.selectedCourseObjFromFilter.CourseMasterId !== undefined || storeObj.state.selectedCourseObjFromFilter.CourseMasterId !== null) {
        moduleService
          .listModules(
            storeObj.state.access_token,
            storeObj.state.selectedCourseObjFromFilter.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Update all Modules in a background
              storeObj.state.selectedMasterClassModuleList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'ModuleId is NULL hence declined GETTING CURRENT MODULE DATA [AFTER UPDATE/DELETE]'
        )
      }
    },
    setElementImageAndType: function () {
      switch (this.ElementObj.Type) {
        case 0:
          this.elementImgSrc = videoicon
          this.elementType = 'Video'
          break
        case 1:
          this.elementImgSrc = challengeicon
          if (parseInt(this.ElementObj.SubType) === parseInt(constants.DescVideoType.Teachback)) {
            this.elementType = 'Teachback'
          } else {
            this.elementType = 'Challenge'
          }
          break
        case 2:
          this.elementImgSrc = reflectionicon
          this.elementType = 'Reflection'
          break
        case 3:
          this.elementImgSrc = mcqicon
          this.elementType = 'MCQ'
          break
        case 4:
          this.elementImgSrc = videoicon
          this.elementType = 'Tookit'
          break
        case 5:
          this.elementImgSrc = videoicon
          this.elementType = 'Diary'
          break
        case 6:
          this.elementImgSrc = noteicon
          this.elementType = 'Note'
          break
        case 7:
          this.elementImgSrc = videoicon
          this.elementType = 'Bonus'
          break
        case 8:
          this.elementImgSrc = documenticon
          this.elementType = 'Note'
          break
        case 9:
          this.elementImgSrc = videoicon
          if (parseInt(this.ElementObj.RDType) === parseInt(constants.DescVideoType.Teachback)) {
            this.elementType = 'Teachback'
          } else {
            this.elementType = 'Descriptive Video'
          }
          break
        case 10:
          this.elementImgSrc = noteicon
          this.elementType = 'Rating'
          break
        case 11:
          this.elementImgSrc = iconadaptivegame
          this.elementType = 'Learning Game'
          break
        case 12:
          this.elementImgSrc = missionicon
          this.elementType = 'Mission'
          break
        case 14:
          this.elementImgSrc = mcqicon
          this.elementType = 'Assessment'
          break
      }
      // this.showDisplayIndex = this.ElementObj.StringIndex
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'update-note-element': UpdateNoteElement,
    'update-post-element': UpdatePostElement,
    'update-video-element': UpdateVideoElement,
    'update-mission-element': UpdateMissionElement,
    'update-video-text-element': UpdateVideoTextElement,
    'update-document-element': UpdateDocumentElement,
    'update-reflection-discussion-element': UpdateReflectionDiscussionElement,
    'update-assessment-element': UpdateAssessmentElement,
    'update-challenge-element': UpdateChallengeElement,
    'add-rule-overlay': AddRuleOverlay,
    'update-mcq-element': UpdateMCQElement,
    'update-bonus-content-element': UpdateBonusContentElement,
    'create-bonus-module-overlay': CreateBonusModuleOverlay,
    'loader': Loader,
    'view-bonus-lesson': ViewBonusLesson,
    'add-bonus-video-overlay': AddBonusVideoOverlay,
    'update-lesson-overlay': UpdateLessonOverlay,
    'view-video-element-overlay': ViewVideoElementOverlay,
    'view-adaptive-game-element-overlay': ViewAdaptiveGameElementOverlay,
    'view-note-element-overlay': ViewNoteElementOverlay,
    'view-mcq-element-overlay': ViewMcqElementOverlay,
    'view-reflection-discussion-overlay': ViewReflectionDiscussionOverlay,
    'view-document-element-overlay': ViewDocumentElementOverlay,
    'view-video-text-element-overlay': ViewVideoTextElementOverlay,
    'view-post-element-overlay': ViewPostElementOverlay,
    'update-adaptive-game-overlay': UpdateAdaptiveGameOverlay
  },
  watch: {
    ElementObj: function (newVal, oldVal) {
      // AK: If element Object changed then set again element Images and its types
      this.setElementImageAndType()
    }
  },
  computed: {
    currentSelectedCourseTypeValue: {
      get: function () {
        return parseInt(this.$store.state.selectedCourseObjFromFilter.Type)
      }
    },
    getRuleOptionVisibility: {
      get: function () {
        if (this.currentSelectedCourseTypeValue === constants.CourseType.RecommendationAssessment) {
          return (this.ElementObj.Type === 1 || this.ElementObj.Type === 2 || this.ElementObj.Type === 3 || this.ElementObj.Type === 11 || this.ElementObj.Type === 14) && (this.lessonObj.ModuleType !== constants.ModuleType.Normal)
        } else {
          return (this.ElementObj.Type === 1 || this.ElementObj.Type === 2 || this.ElementObj.Type === 3 || this.ElementObj.Type === 11 || this.ElementObj.Type === 14) && (this.lessonObj.ModuleType === constants.ModuleType.Normal)
        }
      }
    },
    getStringIndex: {
      get: function () {
        return this.showDisplayIndex
      }
    },
    getElementList: {
      get: function () {
        return this.elementList
      }
    },
    getIncludeInProgressSrcValue: {
      get: function () {
        if (parseInt(this.ElementObj.Type) === 0) {
          this.ElementObj.IncludeInProgress = true
        }
        this.includeInProgressSrc = this.ElementObj.IncludeInProgress ? includeinprogressicon : excludeinprogressicon
        return this.includeInProgressSrc
      }
    },
    getIncludeInProgressTooltipValue: {
      get: function () {
        if (parseInt(this.ElementObj.Type) === 0) {
          this.ElementObj.IncludeInProgress = true
        }
        this.includeInProgressTooltip = this.ElementObj.IncludeInProgress ? constants.Include_In_Progress_True_Tooltip_Text : constants.Include_In_Progress_False_Tooltip_Text
        return this.includeInProgressTooltip
      }
    },
    getIsBonusContentTooltipValue: {
      get: function () {
        this.isBonusContentTooltip = parseInt(this.ElementObj.Type) === 7 ? constants.Is_Bonus_Content_True_Tooltip_Text : constants.Is_Bonus_Content_False_Tooltip_Text
        return this.isBonusContentTooltip
      }
    },
    getCurrentMissionElementObj: {
      get: function () {
        // console.log('computed: getCurrentMissionElementObj: ' + JSON.stringify(this.currMissionElementObj))
        return this.currMissionElementObj
      }
    },
    getDisplayIndexLength: {
      get: function () {
        // console.log(this.displayIndexLen)
        return parseInt(this.displayIndexLen)
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default;
}
.opacity-point-2 {
  opacity: 0.5;
}
.opacity-point-5 {
  opacity: 0.9;
}
.left-icon-div {
  float: left;
  width: 5%;
}
.right-element-duration-div {
  float: right;
  width: 83%;
}
.middle-element-type-name-div {
  margin: 0 auto;
}
.element-type-font-style {
  font-weight: bold;
}
.element-icon-width-height {
  width: 23px;
  height: 14px;
}
.include-in-progress-width-height {
  width: 20px;
  height: 20px;
}
.padding-top-5px {
  padding-top: 5px;
}
.element-index-font-style {
  font-size: 19px;
  color: #ffffff;
}
.element-index-circle-width-height {
  width: 35px;
  height: 35px;
  background-color: #f39c12;
}
.roundered-corner {
  border-radius: 17.5px;
}
.element-list {
  width: 90%;
}
.element-name-style {
  font-weight: lighter;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.icon-width-height {
  width: 18px;
  height: 22px;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.align-center {
  margin: 0 auto !important;
}
.text-align-left {
  text-align: left;
}
.element-name-text-size {
  font-size: 16px;
}
.orange-text-color {
  color: #f39c12;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 3px solid #efe700 !important;
}
.padding-right-0Perc{
  padding-right: 0%;
}
.padding-left-0Perc{
  padding-left: 0%;
}
.width-5Perc{
  width: 5%;
}
.float-left{
  float: left;
}
.margin-5Perc {
  margin:5%;
}
.tooltip1 {
    position: relative;
    /* display: inline-block; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    /* width: 133px; */
    width: -webkit-fill-available;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0.5px;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 140%;
    margin-left: -60px;
    font-size: 11px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.margin-right-0px {
  margin-right: 0px;
}
.margin-0px {
  margin: 0px;
}
.margin-left-2px {
  margin-left: 2px;
}
.displayFlex {
  display: flex;
  align-items: center;
}
.fontSize12px {
  font-size: 12px !important;
}
.fontSize14px {
  font-size: 14px !important;
}
.fontSize17px {
  font-size: 17px;
}
.widthInherit {
  width: inherit;
}
.marginTop2perc {
  margin-top:2%;
}
.background-color-orange {
  background-color: #EE6B1F;
}
.font-weight-bold {
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/components/ElementList.vue